export const isVercelPreview = (): boolean =>
  window?.location?.hostname.endsWith('hashicorp.vercel.app');
